require('./LegalConfirmation.scss');

// @ vendors
const React = require('react');
const { Component } = require('react');
const PropTypes = require('prop-types');

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const { recordLink } = require("utilities/tagging");

// @components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const PreContractualMailInfoAlt = require('components/contactCenter/preContractualMailInfoAlt/preContractualMailInfoAlt');

// Local components
const ContractsConfirmationCheckboxGroup = require('../ContractsConfirmationCheckboxGroup/ContractsConfirmationCheckboxGroup');
const { ACCOUNT_TYPE_E_LOAN, CONTRACT_INDEX_DEPOSIT_PAYROLL } = require('constants/index');

const {
    CHECKING_ACCOUNT_PRODUCT_ALIAS,
    DEPOSIT_OPEN_EXCEPTION,
    DEPOSIT_OPEN_RENOVATION,
    E_ACCOUNT_LOAN_PRODUCT_ALIAS,
} = require('constants/hiringProductInformation');
const { BUTTON_CLICK, SEND_MAIL_INFORMATION, UPDATE_EMAIL } = require('constants/tagging');
const allowedNoInfoDepositsAndAccounts = [
    'deposit-eighteen-months', 
    'deposit-eighteen-months-retention', 
    'combined-deposit', 
    'deposit-twentyfour-months-retention', 
    'depositnm', 
    'deposit', 
    'deposittransfer',
    'depositrenewal',
    'depositexpired',
    CONTRACT_INDEX_DEPOSIT_PAYROLL,
    ACCOUNT_TYPE_E_LOAN,
];
const { CONTRACT_INDEX_COMBINED_DEPOSIT } = require("constants/index");

class LegalConfirmation extends Component {

    getProduct = (contractName) => {
        const productMap = {
            'checking-account': CHECKING_ACCOUNT_PRODUCT_ALIAS,
            'e-account-loan': E_ACCOUNT_LOAN_PRODUCT_ALIAS,
            'deposit-thirteen-months-excepciones': DEPOSIT_OPEN_EXCEPTION,
            'deposit-thirteen-months-renovacion-excepciones': DEPOSIT_OPEN_RENOVATION
        }

        return productMap[contractName]
    }

    render () {
        const {
            alternativePositionedCheckboxes,
            alternativeLegalTextHeight,
            confirmationCheckboxes,
            documentId,
            getDocumentsOkApiById,
            immProfileFields,
            preContractualMail,
            requestProfile,
            sendPreContractualMail,
            updateConfirmationCheckboxes,
            wizardState,
            subType,
            type,
            standar,
            productName,
            gestorCrossEnabled,
            immHiringProductInformation,
            setTermsAndCondsText,
            onLegalTextRead,
            hasPolling,
            preContractualMailPolling,
            biggerLegalTexts,
            uniqueLegalKey,
            uniqueLegalValues,
            emailInfo,
            customCategoryEvent,
            match,
            getPrecontractualDocumentURLOrID,
            component,
            contractBuilder,
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const profileError = immProfileFields.get('error');
        const precontractualLink = gestorCrossEnabled ? immHiringProductInformation.getIn(['precontractualLinksList', 'field_contract_link_text']) : wizardState.get('precontractualLink');
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : wizardState.get('information_step1');
        const hasBeenEmailSent = !preContractualMail.get('mailSent');
        const contractName = wizardState.get('name_contract');
        const eAccountType = wizardState.getIn(['mainAccount', 'data', 'accountDefinition', 'accountType'], null)
        const product = this.getProduct(contractName)
        const name = wizardState.getIn(['deposit_product', 'name']);
        const context = wizardState.getIn(['deposit_product', 'context']);
        const originCountry = immProfileFields.get('originCountry')
        const depositLegalText = {
            ...wizardState.get('depositLegalText').toJS(),
        }

        const sendMailParams = {
            subType,
            type,
            standar,
            productName,
            product,
            emailInfo,
            ...(['deposit-eighteen-months-retention',CONTRACT_INDEX_COMBINED_DEPOSIT].includes(contractName) && { ref: standar }),
            ...(name && context && { name: `${context}-${name}` })
        }
        let content = null;
        if (__CONTACT_CENTER__ && (information || allowedNoInfoDepositsAndAccounts.includes(contractName))) {
            if (hasPolling) {
                const disableSendEmailButton = !preContractualMailPolling.getIn(["documents","success"]) || !preContractualMail.get("isLegalTextRead");
                content = (
                    <PreContractualMailInfoAlt
                        contractBuilder={contractBuilder}
                        alternativeLegalTextHeight={alternativeLegalTextHeight}
                        documentId={documentId}
                        email={clientEmail}
                        getDocumentsOkApiById={getDocumentsOkApiById}
                        alternativePositionedCheckboxes={alternativePositionedCheckboxes}
                        sendEmail={sendPreContractualMail}
                        requestProfile={requestProfile}
                        preContractualMailPolling={preContractualMailPolling}
                        preContractualMail={preContractualMail}
                        profileError={profileError}
                        contractName={contractName}
                        eAccountType={eAccountType}
                        sendMailParams={sendMailParams}
                        isLegalTextRead={preContractualMail.get("isLegalTextRead")}
                        onLegalTextRead={onLegalTextRead}
                        disableSendButton={disableSendEmailButton}
                        hasPolling={hasPolling}
                        updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                        uniqueLegalKey={uniqueLegalKey}
                        uniqueLegalValues={uniqueLegalValues}
                        confirmationCheckboxes={confirmationCheckboxes}
                        precontractualLink={precontractualLink}
                        areDisabled={hasBeenEmailSent}
                        setTermsAndCondsText={setTermsAndCondsText}
                        tagSendEmailEvent={() => recordLink(customCategoryEvent || window.utag_last_name, BUTTON_CLICK, SEND_MAIL_INFORMATION)}
                        tagRefreshMailEvent={() => recordLink(customCategoryEvent || window.utag_last_name, BUTTON_CLICK, UPDATE_EMAIL)}
                        customCategoryEvent={customCategoryEvent}
                        match={match}
                        originCountry={originCountry}
                        getPrecontractualDocumentURLOrID={getPrecontractualDocumentURLOrID}
                        contractWizard={wizardState}
                        component={component}
                        depositLegalText={depositLegalText}
                    />
                );
            }
            else {
                content = (
                    <React.Fragment>
                        <PreContractualMailInfo
                            email={clientEmail}
                            sendEmail={sendPreContractualMail}
                            requestProfile={requestProfile}
                            preContractualMail={preContractualMail}
                            profileError={profileError}
                            contractName={contractName}
                            eAccountType={eAccountType}
                            sendMailParams={sendMailParams}
                            biggerLegalTexts={biggerLegalTexts}
                        />
                        <ContractsConfirmationCheckboxGroup
                            updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                            confirmationCheckboxes={confirmationCheckboxes}
                            precontractualLink={precontractualLink}
                            areDisabled={hasBeenEmailSent}
                            setTermsAndCondsText={setTermsAndCondsText}
                            customCategoryEvent={customCategoryEvent}
                            match={match}
                            contractWizard={wizardState}
                        />
                    </React.Fragment>
                );
            }
        }

        return (
            <article className="legal-confirmation">
                <section className="contract-confirmation-step__confirmation-section">
                    {content}
                </section>
            </article>
        );
    }
}

LegalConfirmation.propTypes = {
    alternativeLegalTextHeight: PropTypes.string,
    alternativePositionedCheckboxes: PropTypes.bool,
    wizardState: PropTypes.object.isRequired,
    confirmationCheckboxes: PropTypes.object,
    contractBuilder: PropTypes.object,
    documentId: PropTypes.string,
    getDocumentsOkApiById: PropTypes.func,
    immProfileFields: PropTypes.object,
    updateConfirmationCheckboxes: PropTypes.func,
    uniqueLegalKey: PropTypes.string,
    sendPreContractualMail : PropTypes.func,
    requestProfile:PropTypes.func,
    preContractualMail:PropTypes.object.isRequired,
    subType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    standar:  PropTypes.string.isRequired,
    productName: PropTypes.string,
    immHiringProductInformation: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    onLegalTextRead: PropTypes.func,
    hasPolling: PropTypes.bool,
    title: PropTypes.string,
    currentProduct: PropTypes.string,
    biggerLegalTexts: PropTypes.bool,
    preContractualMailPolling: PropTypes.object.isRequired,
    emailInfo: PropTypes.object.isRequired,
    customCategoryEvent: PropTypes.string
};

LegalConfirmation.defaultProps = {
    hasPolling: false,
    documentId: null,
    getDocumentsOkApiById: () => {},
    onLegalTextRead: null,
    title: null,
    currentProduct: null,
    uniqueLegalKey: null,
    uniqueLegalValues: [],
    customCategoryEvent: null
}

module.exports = LegalConfirmation;